import React from 'react';

import { isEmpty } from 'util/utils';

const HeaderRightSidebar = (props) => {
  if (isEmpty(props.activeClass)) return null;

  return (
    <div className={`HeaderRightSidebar active ${props.activeClass}`}>
      <div
        className="headerRightOverlay"
        onMouseEnter={props.handleOut}
        onMouseOver={props.handleOut}
        onKeyDown={props.handleOut}
        onClick={props.onClick}
      />
      <div className="headerRightSidebarTop"></div>
      <div className="dropdownRightSide">{props.children}</div>
    </div>
  );
};
export default React.memo(HeaderRightSidebar);
